module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_0.3583dce7.png";